import { Route } from '@angular/router';
import { ROUTE_PATH } from '../../routing/RoutePath.const';
import { PreventInIframeGuard } from '../../routing/prevent-in-iframe.guard';

export const privatePagesRoutes: Route[] = [
  {
    path: ROUTE_PATH.USER_PROFILE,
    loadChildren: () =>
      import('./user-profile-page/user-profile-page.module').then(
        (m) => m.UserProfilePageModule
      ),
  },
  {
    path: ROUTE_PATH.SALON_VISITED,
    loadChildren: () =>
      import('./salon-visited-page/salon-visited-page.module').then(
        (m) => m.SalonVisitedPageModule
      ),
  },
  {
    path: ROUTE_PATH.APPOINTMENT_HISTORY,
    loadChildren: () =>
      import('./appointment-history-page/appointment-history-page.module').then(
        (m) => m.AppointmentHistoryPageModule
      ),
  },
  {
    path: ROUTE_PATH.APPOINTMENT_DETAILS,
    loadChildren: () =>
      import('./appointment-details-page/appointment-details-page.module').then(
        (m) => m.AppointmentDetailsPageModule
      ),
  },
  {
    path: ROUTE_PATH.QR_CHECKIN_CONFIG,
    loadChildren: () =>
      import('./qr-checkin-config-page/qr-checkin-config-page.module').then(
        (m) => m.QrCheckinConfigPageModule
      ),
    canActivate: [PreventInIframeGuard],
  },
  {
    path: ROUTE_PATH.QR_CHECKIN_SUCCESS,
    loadChildren: () =>
      import('./qr-checkin-success-page/qr-checkin-success-page.module').then(
        (m) => m.QrCheckinSuccessPageModule
      ),
    canActivate: [PreventInIframeGuard],
  },
  {
    path: '*',
    pathMatch: 'full',
    redirectTo: ROUTE_PATH.USER_PROFILE,
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: ROUTE_PATH.USER_PROFILE,
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: ROUTE_PATH.USER_PROFILE,
  },
];
